import React from "react";

interface SelectInputProps {
  options: { value?: string | number; label?: string }[];
  value?: string | number;
  disabled?: boolean;
  classes?: string;
  rounded?:string;
  padding?:string;
  bg?:string;
  border?:string;
  onChange: (value: string) => void;
}

const SelectInput: React.FC<SelectInputProps> = ({
  options,
  value,
  disabled,
  classes,
  onChange,
  rounded,
  padding,
  border,
  bg,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(event.target.value);
  };

  return (
    <select
      className={`w-full select-wrapper  rounded-full  focus:ring-primary-red  focus:outline-none  focus:ring-1 ${bg && bg} ${classes}`}
      value={value}
      disabled={disabled}
      onChange={handleChange}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value} className="py-6">
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default SelectInput;
